import React from 'react';
import logo from '../../images/logo/Stargiga.png';
import './PremiumLoader.css';

export default function PremiumLoader({ visible, hiding }) {
	return (
		<div
			id="loading-area"
			className={`premium-loader ${!visible || hiding ? 'premium-loader--hidden' : ''}`}
			aria-hidden={!visible}
		>
			<div className="premium-loader__backdrop" />
			<div className="premium-loader__content">
				<div className="premium-loader__rings">
					<div className="premium-loader__ring premium-loader__ring--outer" />
				</div>
				<div className="premium-loader__logo-wrapper">
					<img
						src={logo}
						alt="Star Giga"
						className="premium-loader__logo"
					/>
				</div>
			</div>
		</div>
	);
}
